import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Journal from "../../../containers/modules/accounting/journal";
import JournalDetail from "./journal/detail";

export default function JournalRoute(props) {
  const { authUser } = props;
  return (
    <Route path="journal">
      <Route
        index
        element={
          <AccessControl
            name={"Journal List"}
            auth={authUser}
            component={() => <Journal authUser={authUser} />}
          />
        }
      />
      <Route
        path="detail/:id"
        element={
          <AccessControl
            name={"Journal Detail List"}
            auth={authUser}
            component={() => <JournalDetail />}
          />
        }
      />
    </Route>
  );
}
